export const CONTACT = {
  people: [
    { name: "Lewis", phone: "0481 730 687" },
    { name: "Emily", phone: "0437 160 216" },
  ],
  email: "hishershim@gmail.com",
  area: "Moreton Bay · Sunshine Coast · North Brisbane",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1726471760435-1646fa0c02ef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBob21lJTIwYXJjaGl0ZWN0dXJlJTIwZXh0ZXJpb3IlMjBkYXJrfGVufDB8fHx8MTc4Njc2Njg2OXww&ixlib=rb-4.1.0&q=85",
  carpentry: "https://images.unsplash.com/photo-1544164560-adac3045edb2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBjYXJwZW50cnklMjB3b29kd29ya2luZyUyMGRldGFpbHN8ZW58MHx8fHwxNzg2NzY2ODY5fDA&ixlib=rb-4.1.0&q=85",
  decking: "https://images.unsplash.com/photo-1705409835795-03d775f8657a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxwcmVtaXVtJTIwbGFuZHNjYXBpbmclMjBkZWNraW5nJTIwZ2FyZGVuJTIwbmlnaHR8ZW58MHx8fHwxNzg2NzY2ODY5fDA&ixlib=rb-4.1.0&q=85",
  handyman: "https://images.unsplash.com/photo-1520372561567-bac27b0e5fa1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHw0fHxjYXJwZW50ZXIlMjB0b29scyUyMHdvb2QlMjB0YWJsZSUyMGRhcmt8ZW58MHx8fHwxNzg2NzY2ODg5fDA&ixlib=rb-4.1.0&q=85",
  fencing: "https://images.unsplash.com/photo-1691821331552-ab4f12500a24?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjB3b29kZW4lMjBmZW5jZSUyMGhvbWUlMjBleHRlcmlvcnxlbnwwfHx8MTc4Njc2Njg4OXww&ixlib=rb-4.1.0&q=85",
};

export const SERVICES = [
  {
    id: "property-maintenance",
    title: "Domestic & Commercial Property Maintenance",
    short: "Property Maintenance",
    description:
      "Planned and reactive maintenance for homes, rentals and business premises — repairs, refurbishments, inspections and everything in between. One call, whole property sorted.",
    image: IMAGES.hero,
  },
  {
    id: "carpentry",
    title: "Carpentry",
    short: "Carpentry",
    description:
      "Bespoke and repair carpentry: doors, skirting, shelving, stud walls and custom timber work — measured twice, finished to last.",
    image: IMAGES.carpentry,
  },
  {
    id: "fencing",
    title: "Fencing",
    short: "Fencing",
    description:
      "Supply and installation of panel, featheredge and picket fencing, plus repairs to storm-damaged runs, posts and gates.",
    image: IMAGES.fencing,
  },
  {
    id: "decking",
    title: "Decking",
    short: "Decking",
    description:
      "Design and build of timber and composite decking — from simple platforms to multi-level entertaining spaces that earn their keep all summer.",
    image: IMAGES.decking,
  },
  {
    id: "landscaping",
    title: "Landscaping",
    short: "Landscaping",
    description:
      "Garden transformations: turfing, planting, patios, raised beds and full tidy-ups that bring tired outdoor spaces back to life.",
    image: IMAGES.decking,
  },
  {
    id: "handyman",
    title: "Handyman",
    short: "Handyman",
    description:
      "The to-do list, done: flat-pack furniture, hanging and mounting, re-siliconing, minor plumbing and electrics, and odd jobs of every shape.",
    image: IMAGES.handyman,
  },
];

export const MANIFESTO = [
  {
    number: "01",
    title: "Trust",
    text: "We treat your home like it's our own — tidy boots, honest quotes and no surprises on the invoice. If something doesn't need doing, we'll tell you.",
  },
  {
    number: "02",
    title: "Craft",
    text: "From a wobbly fence post to a full deck build, we sweat the details others skip. Straight lines, solid fixings, finishes that last.",
  },
  {
    number: "03",
    title: "Care",
    text: "One friendly team for the whole list — domestic or commercial, big job or small. We turn up when we say we will, and we leave it cleaner than we found it.",
  },
];

export const FAQS = [
  {
    q: "Which areas do you cover?",
    a: "We're a local team covering Moreton Bay, the Sunshine Coast and North Brisbane. Not sure if we reach you? Send us a message through the booking form and we'll confirm straight away.",
  },
  {
    q: "Do you charge for quotes?",
    a: "No — every quote is free and comes with no obligation. We'll look at the job, talk through the options and give you a clear, fixed price before any work starts.",
  },
  {
    q: "Are you insured?",
    a: "Yes. We carry public liability insurance and treat every property — and everyone in it — with care. Details are happily shared on request.",
  },
  {
    q: "Do you take on commercial work as well as domestic?",
    a: "Absolutely. We look after homes, rental properties, offices, shops and hospitality premises — from one-off repairs to ongoing maintenance agreements.",
  },
  {
    q: "Is any job too small?",
    a: "Never. Hanging a mirror, fixing a hinge, re-felting a shed — the small jobs are half of what we do, and they get the same care as the big ones.",
  },
  {
    q: "How do I book?",
    a: "Use the booking form on our About page, or give us a call or email. Tell us what needs doing and we'll come back to you within one working day with the next steps.",
  },
  {
    q: "How does payment work?",
    a: "The price is agreed upfront before we start. For most jobs you pay on completion, once you're happy with the work. Larger projects may be staged — always agreed in writing first.",
  },
  {
    q: "Can we request a male or female tradesperson?",
    a: "Of course. We're a husband-and-wife team — Lewis handles much of the carpentry and construction while Emily covers maintenance, finishing and garden care. If you'd prefer Emily or Lewis for your job, just mention it in the booking form and we'll make it happen.",
  },
];

export const MARQUEE_ITEMS = [
  "Property Maintenance",
  "Carpentry",
  "Fencing",
  "Decking",
  "Landscaping",
  "Handyman",
];

export const GALLERY = [
  {
    src: "/assets/colorbond-fence.webp",
    title: "Colorbond fence replacement",
    tag: "Before & After",
    desc: "A leaning hardwood fence replaced with a clean Colorbond run — straight, private and storm-ready.",
  },
  {
    src: "/assets/timber-fence.webp",
    title: "Storm-damaged timber fence repair",
    tag: "Before & After",
    desc: "Fallen tree section cleared, then palings and rails rebuilt to match the original fence line.",
  },
  {
    src: "/assets/gazebo-roof.webp",
    title: "Gazebo roof build",
    tag: "Frame to Finish",
    desc: "Custom timber hip frame sheeted in corrugated steel — built to handle the QLD wet season.",
  },
  {
    src: "/assets/retaining-wall.webp",
    title: "Concrete sleeper retaining wall",
    tag: "Before & After",
    desc: "Rotting timber sleeper wall replaced with durable concrete sleepers and steel posts, built to last.",
  },
  {
    src: "/assets/staircase-wall.webp",
    title: "Staircase wall enclosure",
    tag: "Frame to Finish",
    desc: "An open stairwell framed, sheeted and finished into a clean, solid feature wall.",
  },
  {
    src: "/assets/interior-doors.webp",
    title: "Interior wall & double doors",
    tag: "Before & After",
    desc: "New stud wall framed, sheeted and painted, with double doors hung to finish the space.",
  },
  {
    src: "/assets/garden-lawn.webp",
    title: "Garden & lawn care",
    tag: "Landscaping",
    desc: "Hedges shaped, beds edged and lawns kept lush — regular care that keeps gardens looking their best.",
  },
  {
    src: "/assets/clothesline.webp",
    title: "Hills hoist installation",
    tag: "Handyman",
    desc: "A classic Aussie clothesline supplied, installed and set rock-solid — ready for wash day.",
  },
];
